export default {
  accepted_message: "Your bet has been accepted.",
  waiting_message: "Your bet has been waiting.",
  login: "Please login to continue...",
  password_rule: "Password is case sensitive and must be 6 to 10 characters in length.",
  nickname_rule: "You can set nickname for display and login (6 to 15 alphabets or digits). Please note that you can set this nickname only once. You cannot modify or cancel it once it’s been set.",
  change_password_succeed: "Change Password Successfully.",
  add_secondary_succeed: "Set Nickname Successfully.",
  succeed: "You have successfully completed the action!",
  failed: "You have failed to complete the action!",
  no_information_available: "No information is available.",
  select_display_language: "Select your preferred default language.",
  select_odds_type: "Select your preferred default odds type display.",
  select_page_type: "Select your preferred page type as default for displaying in both today and early market page.",
  select_show_score_map: "Enable system to automatically show score map while placing bet.",
  select_default_event_sorting: "Select your preferred default events sorting display.",
  select_market_type: "Select your preferred market.",
  select_page_size: "Select your preferred page size.",
  change_sports_menu_order: "Please drag the sports to change the desired order of sports menu.",
  view_outstanding_bets_in_bet_list: "The outstanding bets may take some time to process. Please go to Bet List to view your latest outstanding bets.",
  time_display_in_gmt_plus_8: "The time above is displayed in GMT+8.",
  select_default_stake: "Enable System To Automatically Input Your Customized Stake And Last Bet Stake.",
  bet_empty: "Your bet slip is empty. Please click on odds in the table to make your bet selection.",
  no_event: "No matches or games available now. Please visit other sport events or games or come back later.",
  no_games_available: "Tidak ada permainan yang tersedia.",
  no_bets: "No Running Bet",
  no_waiting: "No Waiting Bet",
  no_void: "No Void Bet",
  odds_changed: "Odds changed, refresh new odds?",
  confirmation: "Are you confirm to place this bet?",
  olderversion: "An older version detected, click OK to update or press Ctrl-F5.",
  gmt8: "The time above is displayed in GMT+8.",
  no_betting_market: "No Betting Market",
  note_1: "The outstanding bets may take some time to process. Please go to My Bets to view your latest outstanding bets.",
  match_not_started: "Match Not Started",

  banner1a: "PICK A SPORT",
  banner1b: "GET IN THE GAME",
  banner1c: "With a comprehensive selection of over 90 sports and thousands of live matches to bet on, the adrenalin rush never ends. Don’t miss out on your chance to win with our offer of only the best odds and top sports picks on the market.",
  banner2a: "ROLL THE DICE",
  banner2b: "HIT THE JACKPOT",
  banner2c: "Rake in winnings, all while enjoying a rich and immersive casino gaming experience at any of our luxurious suites. Take a seat, play your favourite casino game, and be on the receiving end of quality interaction from live dealers, all from the comfort of wherever you are.",
  banner3a: "GAMING AT ITS FINEST",
  banner3b: "A REVOLUTIONARY EXPERIENCE",
  banner3c: "An extensive selection of games, as far as the eye can see. Get a firsthand taste of it now.",
  banner4a: "OLYMPIC GAMES",
  banner4b: "TOKYO 2020",
  banner4c: "The 2020 Summer Olympics, officially the Games of the XXXII Olympiad and also known as Tokyo 2020, is an upcoming international multi-sport event scheduled to be held from 23 July to 8 August 2021 in Tokyo",
  banner4d: "We Bringing Back The EURO CUP 2020 For You!",
  banner5a: "LIVE SPORTS & GAME HIGHLIGHTS",
  banner5aa: "REACH YOUR COMMUNITY IN REAL TIME",
  banner5b: "Watch the best free Live TV and Highlights on the web and mobile devices",
  banner5c: "Get the latest sports scores anytime, anywhere",

  banner6a: "E-Fighting",
  banner6b: "Play the best fighting games",
  banner6c: "Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight! The more you play, the more you win!",

  banner7a: "NEW ESPORTS INTERFACE",
  banner7b: "ALL NEW EXPERIENCE",
  banner7c: "Extensive Choices of Esports markets, Industry Leading Betting Experience.",
  banner7d: "Popular massive multiplayer, Unbeatable odds & speedy settlement.",
  
  banner8a: "V-GAMES",
  banner8b: "PLAY THE GAMES, AND EXPERIENCE A DIFFERENT KIND OF VICTORY.",
  banner8c: "Experience a whole new level of victory.",
  banner8d: "Immerse yourself in a variety of games, from competitive to fighting, and explore new genres that wil keep you engaged for hours.",

  bannersb: "Enjoy non-stop thrills and excitement with an endless variety of sporting competitions to wager on, both locally and from all across the world. With us, you’ll always have the best odds.",
  bannersl: "Take a break from reality, step right through, and experience for yourself the fantasies that have been brought to life in our vividly detailed virtual games. You’re sure to get addicted. ",
  bannerlc: "Step inside any of our exclusive casino suites, indulge in your classic casino favourites, and lose yourself in an interactive experience featuring gorgeous live dealers.",

  banner10a: "Wishing you a great fun time",
  banner10b: "While you row to the rhythm of roaring drums!",

  banner11a: "FIFA WORLD CUP QATAR 2022 WORLD'S BIGGEST NATIONAL TEAM TOURNAMENT",
  banner11b: "The World Cup 2022 will take place in Qatar from 20 November to 18 December 2022",
  banner11c: "A total of 32 teams, including hosts Qatar, have qualified for the tournament, which will be the first time football’s biggest event takes place in the Middle East.",
  
  join_us1: "MAKE THIS YOUR WORLD",
  join_us2: "With 24/7 action and a spectacular array of products to wager on, we cater to pretty much any and all types of preferences. Plus, we’ve got cool bonuses, ongoing promotions, and efficient payouts to ensure you enjoy the best gaming experience. Take the first step and sign up with us now. It’s quick, easy, and free.",
  join_us3: "JOIN US NOW",

  icon1a: "OPTIMIZED FOR MOBILE",
  icon1b: "Our games are accessible on popular mobile platforms, so you can game on the go on your favourite device",
  icon2a: "ADVANCED SECURITY & SUPPORT",
  icon2b: "Enjoy our games and transact with us with true peace of mind – our website is fully secure to safeguard your privacy and personal info",
  icon3a: "IMMERSIVE EXPERIENCE",
  icon3b: "Indulgent, intuitive, and interactive – we have curated and selectively chosen premium products that will deliver the excitement you seek",
  icon4a: "CUSTOMER SUPPORT",
  icon4b: "Your satisfaction is our priority. We would to hear from you should you have any feedback or queries that would help us serve you better",
  footer1a: "Underage Gambling",
  footer1b: "Gambling is illegal for kids under the age of 18. Every state prohibits gambling by minors.{fvalue} will carry out age verification randomly and winnings will be forfeited if the gambler is below 18 years old.© 2004-2019. {fvalue} is An Internationally Registered Trademark (Licensed Sports Bookmaker). All Rights Reserved.",

  contactus_title1: "Customer Service specialists are available to answer all your questions including payment concerns in English and Chinese language.",
  contactus_title2: "International call charges may apply to you. Phone calls to us may be recorded for customer protection, information verification, quality assurance purposes and regulatory compliance.",

  days: "Hari",
  hours: "Jam",
  mins: "Menit",
  secs: "Detik",
  ldiff_changed: "Percent has changed",
  no_room: "Tidak ada kamar yang tersedia. Silakan pilih opsi lain dan cari lagi atau kembali lagi nanti.",
  people_in_this_room: "Orang di ruangan ini",
  room_full: "Kamar ini sudah penuh",
  room_joined: "Anda telah bergabung di ruangan ini",
  my_room: "Kamarku",
  pin_code: "eg: 123456",
  no_matches: "Tidak ada pertandingan atau game yang tersedia sekarang.",
  are_you_sure: "Anda yakin akan melanjutkan tindakan ini?",
  accept_terms: "Dengan mencentang, Anda mengonfirmasi bahwa Anda telah membaca, memahami, dan menyetujui syarat dan ketentuan di atas.",
  accept_required: "Harap baca, pahami, dan setujui<br />syarat dan ketentuan di atas sebelum melanjutkan.",
  must_accept_better_odds: "Secara default, taruhan tempat akan secara otomatis menerima peluang yang lebih baik. Silakan lihat Syarat & Ketentuan untuk informasi lebih lanjut.",
  maintenance_notice: "Saat ini, kami sedang melakukan pemeliharaan sistem. Silakan coba lagi nanti.",
  not_winning_prize_in_this_tournament: "Tidak memenangkan hadiah di turnamen ini",
  you_did_not_join_this_room: "Anda tidak bergabung dengan ruangan ini",
  deduct_confirm: "Ini akan memulai permainan dan kredit Anda akan dikurangi. <br /> Apakah Anda yakin ingin melanjutkan?",
  over_max_match: "Pertandingan di liga ini melebihi jumlah maksimum pertandingan yang dapat dipilih.<br />Harap perluas liga dan pilih pertandingan yang diinginkan.",

  //tournament
  button_skip: "Lewati tur",
  button_previous: "Sebelumnya",
  button_next: "Berikutnya",
  button_stop: "Selesai",
  button_continue: "Lanjutkan",
  tour_content_1: "<h6>Selamat datang di turnamen WBET</h6><p>Kami dengan senang hati mengumumkan turnamen baru yang menarik khusus untuk pendukung situs kami.</p>",
  tour_content_2: "<h6>Ruang publik</h6><p>Anggota terlibat dalam permainan kompetitif satu sama lain, biasanya dengan biaya masuk.</p>",
  tour_content_3: "<h6>Ruang pribadi</h6><p>Anggota dapat membuka ruang untuk bermain bersama teman dengan menggunakan pin undangan untuk masuk.</p>",
  tour_content_4: "<h6>Ruang publik gratis</h6><p>Diselenggarakan oleh berbagai organisasi selama acara khusus khusus untuk anggota, menawarkan partisipasi gratis.</p>",
  tour_content_5: "<h6>Total pemain dapat bergabung & mengisi daya</h6><p>Pemain : Kapasitas ruangan.</p><p>Biaya Masuk: Penawaran berdasarkan Kamar ( Mata Uang Pemegang Akun).</ p>",
  tour_content_6: "<h6>Detail ruangan</h6><p>Klik di sini untuk melihat pratinjau statika ruangan dan bergabung ke ruangan.</p>",
  tour_content_7: "<h6>Detail kolam</h6><p>Total hadiah Pool untuk pemenang & ID kamar unik untuk dicari.</p>",
  tour_content_8: "<h6>Detail awal room</h6><p>Status room & Tampilan waktu bergabung terakhir.</p>",
  tour_content_9: "<h6>Buat ruang pribadi</h6><p>Untuk membuat ruang pribadi, mainkan dan undang teman untuk bergabung dengan pin untuk masuk.</p>",
  tour_content_10: "<h6>Peringkat Poin</h6><p>Fitur ini untuk menampilkan poin bagi pemain yang melihat dan melacak hasilnya.</p>",

  time_machine_information_HDP: "WBET Time Machine [HDP] digunakan untuk memprediksi tim mana yang akan mencetak gol terbanyak selama periode yang dipilih.",
  time_machine_information_OU: "WBET Time Machine [OU] digunakan untuk memprediksi jumlah total gol selama periode yang dipilih."

};
